import { fetchGetBusinessPossibleAppointments } from '../../../repositories/announcements/v1/get-business-possible-appointments';
import { IApplicationContext } from '../../../types/applicationContext';
import { mappers } from './mappers';
import {
  TBusinessAppoinmentResult,
  TBusinessAppoinmentError,
  TBusinessAppoinment,
  EBusinessAppoinmentStatus,
} from './types';

export async function getBusinessPossibleAppointments(
  dependencies: Pick<IApplicationContext, 'httpApi' | 'logger'>,
): Promise<TBusinessAppoinment> {
  const { httpApi, logger } = dependencies;

  try {
    return (await fetchGetBusinessPossibleAppointments<TBusinessAppoinmentResult, TBusinessAppoinmentError>({
      httpApi,
      parameters: {},
      mappers,
    })) as TBusinessAppoinment;
  } catch (error) {
    logger.error(error, {
      degradation: 'Запрашивались назначения готового бизнеса',
      description: 'announcements /public/v1/get-business-possible-appointments/ rejection error',
      domain: 'src/shared/services/businessPossibleAppointments/getBusinessPossibleAppointments/service.ts',
      errorName: 'Error',
      errorStack: error.errorStack,
    });

    return {
      businessAppointments: null,
      message: error.message,
      status: EBusinessAppoinmentStatus.CriticalError,
    };
  }
}
